module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD5SURBVHgBpVPbCYNAEPTOqG1YQjqIJaSE+1Dx0w48O/BT1I8rwRJSgiXYhiCYHYmJLgnhcEFZhhn3NQqHRZIkSggRcnxZlrFtW7PHxJYopcIgCHIS9nVdP7g4y7JwnmeNxxgzOnthHMc5FxB+5Rh44COXePm+r7uuqziR8DvHwPM8by0kMaOUUjsW4bpuv+qwHJpxtBFjJ9BJ50RctoTauNLXDjPSeW5pmmqG9XSy4SB+AcOeCGHTNPpX5VNtSziHbhfZiHBn6CQsx2f9F3TnArq1bbpb9c1hWA7HwCN+ifztbXiXyMU0TeXBux9RhA5RaPOF4CSbv+oJlFBzwzylo0sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/Component 1.png
// module id = GhUs
// module chunks = 1